export enum VisitorBlocks {
  Visitors = 'visitors',
  Schedule = 'schedule',
  HostInformation = 'hostInformation',
  Notes = 'notes',
  InviteName = 'inviteName',
}
